type projectDataCheck = Array<{
  titleId: string,
  title: string,
  content: string,
  buttonId: string,
}>;

export const projectData: projectDataCheck = [
  {
    titleId: "description-1",
    title: "Project 1",
    content:
      "Ipsum dolor sit amet consectetur adipiscing elit. Diam quis enim lobortis scelerisque fermentum dui. Enim sit amet venenatis urna cursus eget nunc scelerisque. Non quam lacus suspendisse faucibus. Tincidunt augue interdum velit euismod in pellentesque massa. Velit egestas dui id ornare arcu. Ac feugiat sed lectus vestibulum. At tellus at urna condimentum mattis pellentesque. Maecenas volutpat blandit aliquam etiam erat velit. Semper risus in hendrerit gravida rutrum.",
    buttonId: "button-1",
  },
  {
    titleId: "description-2",
    title: "Project 2",
    content:
      "Ipsum dolor sit amet consectetur adipiscing elit. Diam quis enim lobortis scelerisque fermentum dui. Enim sit amet venenatis urna cursus eget nunc scelerisque. Non quam lacus suspendisse faucibus. Tincidunt augue interdum velit euismod in pellentesque massa. Velit egestas dui id ornare arcu. Ac feugiat sed lectus vestibulum. At tellus at urna condimentum mattis pellentesque. Maecenas volutpat blandit aliquam etiam erat velit. Semper risus in hendrerit gravida rutrum.",
    buttonId: "button-2",
  },
  {
    titleId: "description-3",
    title: "Project 3",
    content:
      "Ipsum dolor sit amet consectetur adipiscing elit. Diam quis enim lobortis scelerisque fermentum dui. Enim sit amet venenatis urna cursus eget nunc scelerisque. Non quam lacus suspendisse faucibus. Tincidunt augue interdum velit euismod in pellentesque massa. Velit egestas dui id ornare arcu. Ac feugiat sed lectus vestibulum. At tellus at urna condimentum mattis pellentesque. Maecenas volutpat blandit aliquam etiam erat velit. Semper risus in hendrerit gravida rutrum.",
    buttonId: "button-3",
  },
];
